export default "__VITE_ASSET__COSFucSD__"